import React from 'react'

import PropTypes from 'prop-types'
import { Controller, useFormContext } from 'react-hook-form'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { Grid, InputAdornment, TextField, Typography } from '@material-ui/core'

import { Label, Select } from 'components'

import useThirdPartyManagementStepper from 'hooks/useThirdPartyManagementStepper'

import helpers from 'helpers'

const PlanActionFields = ({ users = [], isUsersLoading = false }) => {
  const { control, errors } = useFormContext()
  const { isShow } = useThirdPartyManagementStepper()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Label title="Responsável" marginTopChildren={0}>
          <Controller
            as={
              <Select
                items={users}
                fieldName="email"
                fieldValue="id"
                error={!!errors?.responsibleUserId}
                helperText={errors?.responsibleUserId?.message}
                fullWidth
                disabled={isShow}
                isLoading={isUsersLoading}
              />
            }
            control={control}
            name="responsibleUserId"
            mode="onBlur"
          />
        </Label>
      </Grid>
      <Grid item xs={12} md={3}>
        <Label title="Início *" marginTopChildren={0}>
          <Controller
            as={
              <KeyboardDatePicker
                disablePast
                fullWidth
                format="DD/MM/yyyy"
                inputVariant="outlined"
                invalidDateMessage="Data inválida"
                error={!!errors?.startDate}
                helperText={errors?.startDate?.message}
                onChange={(newValue) => ({ value: newValue })}
                disabled={isShow}
              />
            }
            control={control}
            name="startDate"
            mode="onBlur"
          />
        </Label>
      </Grid>
      <Grid item xs={12} md={3}>
        <Label title="Prazo Final *" marginTopChildren={0}>
          <Controller
            as={
              <KeyboardDatePicker
                disablePast
                fullWidth
                format="DD/MM/yyyy"
                inputVariant="outlined"
                invalidDateMessage="Data inválida"
                error={!!errors?.deadlineDate}
                helperText={errors?.deadlineDate?.message}
                onChange={(newValue) => ({ value: newValue })}
                disabled={isShow}
              />
            }
            control={control}
            name="deadlineDate"
            mode="onBlur"
          />
        </Label>
      </Grid>
      <Grid item xs={12}>
        <Label
          title="O que *"
          description="Ações concretas e objetivas que serão tomadas"
          marginTopChildren={0}
        >
          <Controller
            as={
              <TextField
                variant="outlined"
                multiline
                minRows={3}
                maxRows={10}
                error={!!errors?.what}
                helperText={errors?.what?.message}
                fullWidth
                disabled={isShow}
              />
            }
            control={control}
            name="what"
            mode="onBlur"
          />
        </Label>
      </Grid>
      <Grid item xs={12} md={6}>
        <Label
          title="Como"
          description="Planejamento para execução da ação"
          marginTopChildren={0}
        >
          <Controller
            as={
              <TextField
                variant="outlined"
                multiline
                minRows={3}
                maxRows={10}
                error={!!errors?.how}
                helperText={errors?.how?.message}
                fullWidth
                disabled={isShow}
              />
            }
            control={control}
            name="how"
            mode="onBlur"
          />
        </Label>
      </Grid>
      <Grid item xs={12} md={6}>
        <Label
          title="Porquê"
          description="A meta que se objetiva com a ação"
          marginTopChildren={0}
        >
          <Controller
            as={
              <TextField
                variant="outlined"
                multiline
                minRows={3}
                maxRows={10}
                error={!!errors?.because}
                helperText={errors?.because?.message}
                fullWidth
                disabled={isShow}
              />
            }
            control={control}
            name="because"
            mode="onBlur"
          />
        </Label>
      </Grid>
      <Grid item xs={12} md={6}>
        <Label
          title="Onde"
          description="Em qual setor a ação será realizada"
          marginTopChildren={0}
        >
          <Controller
            as={
              <TextField
                variant="outlined"
                error={!!errors?.where}
                helperText={errors?.where?.message}
                fullWidth
                disabled={isShow}
              />
            }
            control={control}
            name="where"
            mode="onBlur"
          />
        </Label>
      </Grid>
      <Grid item xs={12} md={6}>
        <Label
          title="Quanto"
          description="Impacto financeiro da ação"
          marginTopChildren={0}
        >
          <Controller
            as={
              <TextField
                variant="outlined"
                error={!!errors?.howPrice}
                helperText={errors?.howPrice?.message}
                fullWidth
                disabled={isShow}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography>R$</Typography>
                    </InputAdornment>
                  ),
                }}
              />
            }
            control={control}
            name="howPrice"
            mode="onChange"
            onChange={([event]) =>
              helpers.formatters.currencyInput(event.target.value || '0')
            }
          />
        </Label>
      </Grid>
      <Grid item xs={12}>
        <Label
          title="Link"
          description="Upload de documento e/ou link"
          marginTopChildren={0}
        >
          <Controller
            as={
              <TextField
                variant="outlined"
                error={!!errors?.link}
                helperText={errors?.link?.message}
                fullWidth
                disabled={isShow}
              />
            }
            control={control}
            name="link"
            mode="onBlur"
          />
        </Label>
      </Grid>
    </Grid>
  )
}

PlanActionFields.propTypes = {
  users: PropTypes.array,
  isUsersLoading: PropTypes.bool,
}

export default PlanActionFields
